export const GET_OFFERS = 'GET_OFFERS'
export const GET_OFFERS_SUCCESS = 'GET_OFFERS_SUCCESS'
export const GET_OFFERS_FAILED = 'GET_OFFERS_FAILED'

export const GET_ARTICLES = 'GET_ARTICLES'
export const GET_ARTICLES_SUCCESS = 'GET_ARTICLES_SUCCESS'
export const GET_ARTICLES_FAILED = 'GET_ARTICLES_FAILED'

export const DELETE_ARTICLE_OFFER = 'DELETE_ARTICLE_OFFER'
export const DELETE_ARTICLE_OFFER_SUCCESS = 'DELETE_ARTICLE_OFFER_SUCCESS'
export const DELETE_ARTICLE_OFFER_FAILED = 'DELETE_ARTICLE_OFFER_FAILED'

export const ADD_ARTICLE_OFFER = 'ADD_ARTICLE_OFFER'
export const ADD_ARTICLE_OFFER_SUCCESS = 'ADD_ARTICLE_OFFER_SUCCESS'
export const ADD_ARTICLE_OFFER_FAILED = 'ADD_ARTICLE_OFFER_FAILED'

export const EDIT_ARTICLE_OFFER = 'EDIT_ARTICLE_OFFER'
export const EDIT_ARTICLE_OFFER_SUCCESS = 'EDIT_ARTICLE_OFFER_SUCCESS'
export const EDIT_ARTICLE_OFFER_FAILED = 'EDIT_ARTICLE_OFFER_FAILED'

export enum offerStatus {
  SUCCESS = 'Success'
}

export enum nameType {
  OfferDescription = 'offerDescription',
  ValidForConcepts = 'validForConcepts',
  MixingFromPosition = 'mixingFromPosition',
  File = 'file'
}
